/**
 * pluralize(count, singular, plural?) -> "1 finding" / "5 findings".
 *
 * Count-agreeing noun for UI copy: count === 1 uses `singular`, otherwise
 * `plural` (defaults to `singular + "s"`; pass it for irregulars like
 * "opportunity" -> "opportunities"). The count is thousands-separated
 * (toLocaleString), which matches the OpportunityStatusLine convention, so
 * consolidating that call site onto this helper preserves its formatting. A
 * non-finite count falls back to 0 ("0 findings") so a bad prop never renders
 * "NaN"/"undefined".
 *
 * Lifted from the local helper at pages/Analytics.js:8 (which uses a bare
 * count); that page is a candidate to consolidate onto this shared helper.
 */
export function pluralize(count, singular, plural) {
  const n = Number.isFinite(Number(count)) ? Number(count) : 0;
  const noun = n === 1 ? singular : (plural || `${singular}s`);
  return `${n.toLocaleString()} ${noun}`;
}
